import { gql } from '@apollo/client'

export const CREATE_LUGGAGE_PLAN = gql`
    mutation addLuggage($luggage: LuggageInput!) {
        addLuggage(luggage: $luggage) {
            code
            success
            message
        }
    }
`

export const UPDATE_LUGGAGE_PLAN = gql`
    mutation updateLuggage($luggage_id: NonEmptyString!, $luggage: LuggageInput!) {
        updateLuggage(luggage_id: $luggage_id, luggage: $luggage) {
            code
            success
            message
        }
    }
`
